import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export const FloatingAd = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div data-testid="floating-ad" className="fixed bottom-4 right-4 z-40 w-64 rounded-2xl overflow-hidden shadow-2xl border border-border/60 backdrop-blur-xl bg-card/95 animate-fade-up">
      <button data-testid="close-ad-btn" onClick={() => setOpen(false)}
        className="absolute top-2 right-2 z-10 bg-black/40 text-white rounded-full p-1 hover:bg-black/60">
        <X className="w-3.5 h-3.5" />
      </button>
      <div className="bg-gradient-to-br from-primary to-accent p-4 text-white">
        <Sparkles className="w-6 h-6 mb-2" />
        <p className="font-display font-black text-lg leading-tight">Get 10% OFF</p>
        <p className="text-xs opacity-90 mt-1">Use code <span className="font-bold">AFRICA10</span> at checkout</p>
        <Link to="/products?flash=1" data-testid="ad-cta-btn"
          className="mt-3 inline-block bg-white text-primary text-xs font-bold px-3 py-1.5 rounded-full hover:bg-white/90">
          Shop Flash Sales →
        </Link>
      </div>
    </div>
  );
};
